import {
  ApplicationUserPaymentFeeWithUSDT,
  GetApplicationUserEdit,
} from "./api";

import http from "config/http";

const userApi = {
  getApplicationUserEdit: async () => await http.get(GetApplicationUserEdit),

  applicationUserPaymentFeeWithUSDT: async (body) =>
    await http.post(ApplicationUserPaymentFeeWithUSDT, body, {
      headers: {
        "content-type": "multipart/form-data",
      },
    }),
};

export default userApi;
